<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <div style="padding: 40px; text-align: center; background-color: #f4f4f4;">
      <h1 style="color: #333; font-size: 2rem; margin-bottom: 20px;">
        Unleash the Power of Annaliis - A Sound Design Masterclass
      </h1>
      <p style="font-size: 1.2rem; color: #666; max-width: 900px; margin: 0 auto; margin-bottom: 30px;">
        Discover our growing set of video tutorials designed to help you master Annaliis and unlock the full potential of synthesis.
      </p>
      <h2 style="font-size: 1.5rem; color: #333; margin-bottom: 20px;">
        Explore key topics:
      </h2>
      <div style="text-align: left; background-color: #fff; padding: 30px; border-radius: 8px; box-shadow: 0 2px 5px rgba(0,0,0,0.1); max-width: 1000px; margin: 0 auto;">
        <ul style="list-style: none; padding: 0; margin-left: 20px;">
          <li style="margin-bottom: 15px;">
            <strong>Understanding the Signal Flow:</strong> Learn the signal paths within Annaliis and explore the basics of sound generation using oscillators.
          </li>
          <li style="margin-bottom: 15px;">
            <strong>Crafting Classic Sounds:</strong> Step-by-step guidance on creating a classic seven saw sound and techniques for mixing and tuning oscillators.
          </li>
          <li style="margin-bottom: 15px;">
            <strong>Using Envelopes and Effects:</strong> How to adjust ADSR envelopes for precise sound control and enhance your sounds with effects like chorus and reverb.
          </li>
          <li style="margin-bottom: 15px;">
            <strong>Modulation Techniques:</strong> Techniques to dynamically alter filter cutoff and other parameters, integrating tools like the mod wheel and ADSR.
          </li>
          <li style="margin-bottom: 15px;">
            <strong>Layering for Depth:</strong> Strategies for using Unison modes, detuning, and advanced layering to create rich, dynamic sounds.
          </li>
        </ul>
      </div>
    </div>

    <v-container>
      <h2 class="display-1 mb-8 headline">
        How to Make a Patch.
      </h2>
    </v-container>
    <div
      v-if="acceptedAnalyticsCookies && acceptedMarketingCookies && acceptedPreferencesCookies"
      class="video-wrapper"
    >
      <!-- Using the computed property with index directly in the template -->
      <iframe
        :src="videoUrl(0)"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <div v-else>
      <br>
      <h3>
        📺 Please accept 'Preferences', 'Analytical' and 'Marketing' cookies to view video content. 📺
      </h3>
    </div>
    <br>
    <div class="cta-buttons">
      <button
        style="width: 320px; height: 44px; text-transform: none;"
        class="cta-button download-button"
        @click="handleButtonClick('Buy')"
      >
        Buy Annaliis
      </button>
    </div>
    <v-container>
      <h2 class="display-1 mb-8 headline">
        How to Make a Seven Saw Sound.
      </h2>
    </v-container>
    <div
      v-if="acceptedAnalyticsCookies && acceptedMarketingCookies && acceptedPreferencesCookies"
      class="video-wrapper"
    >
      <!-- Using the computed property with index directly in the template -->
      <iframe
        :src="videoUrl(1)"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <div v-else>
      <br>
      <h3>
        📺 Please accept 'Preferences', 'Analytical' and 'Marketing' cookies to view video content. 📺
      </h3>
    </div>
    <br>
    <div class="cta-buttons">
      <button
        style="width: 320px; height: 44px; text-transform: none;"
        class="cta-button download-button"
        @click="handleButtonClick('Buy')"
      >
        Buy Annaliis
      </button>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Headline',
    data () {
      return {
        videos: [
          'ShuXxCJksrY',
          'WrZDB_JTj68',
          'jHfVSciRQ78'
        ],
        acceptedAnalyticsCookies: false,
        acceptedFunctionalCookies: false,
        acceptedMarketingCookies: false,
        acceptedPreferencesCookies: false,
      }
    },

    computed: {
      videoUrl () {
        // Create a function that returns the URL based on an index
        return (index) => {
          return 'https://www.youtube.com/embed/' + this.videos[index]
        }
      }
    },

    created () {
      // Perform the initial check as soon as the component is created.
      this.checkCookieConsent()
    },
    mounted () {
      // Set up a repeating check every 2 seconds after the component is mounted.
      this.checkInterval = setInterval(this.checkCookieConsent, 2000)
    },

    methods: {
      checkCookieConsent () {
        if (window.cookiehub) {
          this.acceptedAnalyticsCookies = window.cookiehub.hasConsented('analytics')
          this.acceptedFunctionalCookies = window.cookiehub.hasConsented('functional')
          this.acceptedMarketingCookies = window.cookiehub.hasConsented('marketing')
          this.acceptedPreferencesCookies = window.cookiehub.hasConsented('preferences')
        }
      },

      handleButtonClick (buttonType) {
        this.$router.push({ name: 'Buy' })
      },
      isUserLoggedIn () {
        return this.$store.getters.isUserLoggedIn
      },
      userPurchased () {
        return this.$store.getters.purchased
      }
    }
  }
</script>

<style scoped>
.headline {
  /* Presuming this is your existing style for '3 Unique User Interfaces' */
  font-size: 2.5rem; /* Example size, adjust as necessary */
  font-weight: light;
  margin-bottom: 8px;
}

.section-headline {
  /* New style for the individual UI sections, slightly smaller */
  font-size: 2.2rem; /* Slightly smaller than the main headline */
  font-weight: light;
  margin-bottom: 8px;
}

.middle-third {
    width: 45%; /* 100 / 3 to get one-third */
    margin: 0 auto; /* Center the div */
  }

  @media (max-width: 960px) {
    .middle-third {
      width: 100%; /* On smaller screens, take full width */
    }
  }

/* If you have other content in .info-section that shouldn't be centered,
   you'll need to wrap the list in another div that will be flexed */
.list-container {
  display: flex;
  justify-content: center; /* Centers the child horizontally */
  width: 100%; /* Takes up 100% of the info-section */
}

.info-section li {
  text-align: left; /* Ensuring list items are also aligned to the left if needed */
  line-height: 1.5; /* Improved readability for list items */
}

@media (max-width: 600px) {
  .image-width {
    width: 100%; /* Full width on smaller screens */
  }
}

.cta-buttons {
  display: flex;
  justify-content: center; /* Centering the buttons */
  padding: 20px;
  gap: 20px; /* Adds space between buttons */
}

.cta-button {
  padding: 10px 40px; /* Increased horizontal padding */
  border: none;
  border-radius: 5px;
  font-size: 18px; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.3s;
  width: 320px;
  min-width: 320px; /* Minimum width */
  background-color: #4CAF50; /* Green */
  color: white;
}

.cta-button:hover {
  opacity: 0.9;
}

.ui-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ui-block {
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.heading {
  font-size: 1.5em;
  color: #333;
}

.content-wrapper {
  max-width: 1200px; /* Max width to align with the image */
  margin: 0 auto; /* Centering the wrapper */
}

.image-width {
  width: 80%; /* This controls the image size relative to its container */
  display: block; /* Ensures the image behaves as a block element, centering with margin auto */
  margin: 0 auto; /* Center the image horizontally */
}

.description {
  width: 80%; /* Make the paragraph the same width as the image */
  margin: 0 auto; /* Center the paragraph horizontally */
  font-size: 1.2em; /* Increase the font size to make it stand out more */
  color: #333; /* Darker color for better readability */
  padding: 20px; /* Add some padding around the text */
  background-color: #f8f8f8; /* Light background color to make the paragraph pop */
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Subtle shadow to lift the text off the page */
}

/* Button styles */
button {
  margin: 10px;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
}

.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  margin: auto; /* Centers the video wrapper */
}
.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Default to half width for larger screens */
@media (min-width: 768px) {
  .video-wrapper {
      width: 50%;
      padding-bottom: 28.125%; /* Adjust the padding-bottom to maintain the aspect ratio */
  }
}

/* Adjust to 80% width for smaller screens (like iPhones) */
@media (max-width: 767px) {
  .video-wrapper {
      width: 80%;
      padding-bottom: 45%; /* Adjust the padding-bottom to maintain the aspect ratio */
  }
}

</style>
